import React, { useEffect, useState } from "react";
import { Container, Row } from "reactstrap";
import Breadcrumb from "Components/Common/Breadcrumb";
// import Filter from "./Filter";
import Detail from "./Detail";
import Filter from "Components/Common/Filter";

const SwLakeIndex = () => {
  document.title = "Нуур тойром";
  
  const [searchField, setSearchField] = useState<any>();

  useEffect(() => {    
  }, [searchField])

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumb title="Гадаргын ус" breadcrumbItem="Нуур тойром" />
          <Row>
            <Filter setSearchField={setSearchField} f_basin_code={true} f_au1_code={true} f_au2_code={true} f_au3_code={true} f_name={true} f_code={true} f_commonType={'cmn_lake_type'}/>
            <Detail searchField={searchField} />
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default SwLakeIndex;
